import { get } from 'vuex-pathify';
export default {
  computed: {
    layersAll: get('layers/layers'),
    modules: get('admin/additionalModules'),
    settings: get('admin/settingsValues'),
    toolsPermissions: get('users/toolsPermissions'),
  },
  methods: {
    hasAccess({ modules = [], settings = [], layers = [] } = {}, logic = 'ALL') {
      const modulesEnabled =
        !modules.length || modules[logic === 'ALL' ? 'every' : 'some'](m => this.modules[m]?.enabled);
      const modulesConfigured =
        !modules.length || modules[logic === 'ALL' ? 'every' : 'some'](m => this.modules[m]?.configured);
      const settingsEnabled = !settings.length || settings[logic === 'ALL' ? 'every' : 'some'](s => this.settings[s]);
      const hasPermissions =
        !modules.length || modules[logic === 'ALL' ? 'every' : 'some'](m => this.toolsPermissions[m]?.main_value > 0);
      const layerAccess = !layers.length || layers[logic === 'ALL' ? 'every' : 'some'](l => !!this.layersAll[l]);
      return modulesEnabled && modulesConfigured && settingsEnabled && hasPermissions && layerAccess;
    },
  },
};
